import { Trash2 } from "lucide-react";
import React from "react";

import {
  IgAutocomplete,
  IgIconButton,
  IgTextField,
  IgTypography,
} from "@intelligems/ig-theme";
import { SimpleCollection } from "@intelligems/ig-types/fe-only/collections";
import { Grid } from "@mui/material";
import { theme } from "@src/theme";

interface CollectionListItemProps {
  selectedCollection: string | null;
  selectedCollections: (string | null)[];
  options: SimpleCollection[];
  isArchived: boolean;
  onChange: (newValue: SimpleCollection | null) => void;
  onRemove: () => void;
}

export const CollectionListItem = ({
  selectedCollection,
  options,
  isArchived,
  onChange,
  onRemove,
  selectedCollections,
}: CollectionListItemProps) => {
  return (
    <Grid
      container
      direction={"row"}
      width={"100%"}
      alignItems={"center"}
      wrap={"nowrap"}
      sx={{ "&:hover .trash-can": { opacity: 1 } }}
    >
      <Grid
        container
        direction={"row"}
        wrap={"nowrap"}
        alignItems={"center"}
        marginBottom={"15px"}
        sx={{
          "&:hover .trash-can": {
            opacity: 1,
          },
        }}
      >
        <IgAutocomplete
          disablePortal
          onChange={(e, newValue) => onChange(newValue)}
          isOptionEqualToValue={(option, value) => {
            return option.handle === value;
          }}
          options={options}
          value={selectedCollection}
          disabled={isArchived}
          sx={{
            "& .Mui-disabled": {
              backgroundColor: "#F5F5F5",
            },
            marginRight: "10px",
          }}
          disableClearable
          fullWidth
          getOptionLabel={(option) => {
            const foundOption = options.find((opt) => opt.handle === option);
            return foundOption ? `${foundOption.title}` : "";
          }}
          getOptionDisabled={(option) => {
            return selectedCollections.includes(option.handle);
          }}
          renderInput={(params) => (
            <IgTextField {...params} label={"Select a Collection"} />
          )}
          renderOption={(props, option) => (
            <li {...props} key={option.handle}>
              <Grid
                container
                direction={"row"}
                alignContent={"center"}
                columnSpacing={2}
              >
                <Grid item>
                  <IgTypography>{option.title}</IgTypography>
                </Grid>
                <Grid item>
                  <IgTypography color={theme.palette.text.secondary}>
                    {option.description || "No description available"}
                  </IgTypography>
                </Grid>
              </Grid>
            </li>
          )}
        />

        {!isArchived && (
          <IgIconButton onClick={onRemove}>
            <Trash2
              size={18}
              className="trash-can"
              color={theme.igIconColors.error}
            />
          </IgIconButton>
        )}
      </Grid>
    </Grid>
  );
};
